import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-LN/SafeDrivingGuideBottomSheet/.eu';
import Na from '@di-shared/features/safe-driving-LN/SafeDrivingGuideBottomSheet/.na';

export interface SafeDrivingGuideBottomSheetProps {
  fromDate: string;
  toDate: string;
}

export default function SafeDrivingGuideBottomSheet({fromDate, toDate}: SafeDrivingGuideBottomSheetProps) {
  return (
    <>
      <Environment.Eu>
        <Environment.Kia>
          <Eu
            fromDate={fromDate}
            toDate={toDate}
          />
        </Environment.Kia>
      </Environment.Eu>
      <Environment.Na>
        <Environment.Kia>
          <Na
            fromDate={fromDate}
            toDate={toDate}
          />
        </Environment.Kia>
      </Environment.Na>
    </>
  );
}
